import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sucu06-element0030002',
  templateUrl: './sucu06-element0030002.component.html',
  styleUrls: ['./sucu06-element0030002.component.less']
})
export class Sucu06Element0030002Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
